
const userSelections = {
  graduacion: "",
  lentes: "",
  tratamiento: "",
  polarization: "",
  color: "",
  graduacionEs: "",
  lentesEs: "",
  tratamientoEs: "",
  polarizationEs: "",
  colorEs: "",
};

let currentOption = {};
const varIdFabricante = {
  "Zeiss": window.variantIDCristal["9900000000202"],
  "Essilor": window.variantIDCristal["9900000000200"],
  "Visual Lens": window.variantIDCristal["9900000000201"],
};
let optionPrices = {};
let totalInitialOption = 0;
const optionImgs = {
  "Lentes orgánicas índice 1.5":
    "https://cdn.shopify.com/s/files/1/0795/5709/9819/files/1.5.png?v=1761139351",
  "Lentes orgánicas índice 1.6":
    "https://cdn.shopify.com/s/files/1/0795/5709/9819/files/1.6.png?v=1761139451",
  "Lentes orgánicas índice 1.67":
    "https://cdn.shopify.com/s/files/1/0795/5709/9819/files/1.67.png?v=1761139451",
  "Lentes orgánicas índice 1.74":
    "https://cdn.shopify.com/s/files/1/0795/5709/9819/files/1.74.png?v=1761139451",
    "Lentes standard con antirreflejante y endurecido":
    "https://cdn.shopify.com/s/files/1/0795/5709/9819/files/tratamientos-standard.png?v=1754999312",
    "Filtro azul para pantallas":
    "https://cdn.shopify.com/s/files/1/0795/5709/9819/files/tratamientos-luz-azul.gif?v=1754999312",
    "Lentes fotocromáticas fotosensibles":
    "https://cdn.shopify.com/s/files/1/0795/5709/9819/files/tratamiento-fotocromatico.gif?v=1754999312",
    "Lentes de sol graduadas":
    "https://cdn.shopify.com/s/files/1/0795/5709/9819/files/tratamientos-sol-graduado.png?v=1754999312",
    "Gris":
    "https://cdn.shopify.com/s/files/1/0795/5709/9819/files/Gris.jpg?v=1761140777",
    "Verde":
    "https://cdn.shopify.com/s/files/1/0795/5709/9819/files/Verde_9082914f-ace2-4a9c-88df-ca9567ae74bf.jpg?v=1761140777",
    "Marrón":
    "https://cdn.shopify.com/s/files/1/0795/5709/9819/files/Marro.jpg?v=1761140777",
    "Polarizado":
    "https://cdn.shopify.com/s/files/1/0795/5709/9819/files/polarizado.gif?v=1761140657",
    "Sin polarizar":
    "https://cdn.shopify.com/s/files/1/0795/5709/9819/files/sin.jpg?v=1761140656",
    "Zeiss":
    "https://cdn.shopify.com/s/files/1/0795/5709/9819/files/Zeiss-Logo.png?v=1751885829",
    "Essilor":
    "https://cdn.shopify.com/s/files/1/0795/5709/9819/files/logo-dossier-essilor-2023.png?v=1761133959",
    "Visual Lens":
    "https://cdn.shopify.com/s/files/1/0795/5709/9819/files/visual-lens-logo.jpg?v=1761136927",
};

document.addEventListener("DOMContentLoaded", function () {
  console.log("Customizer script loaded");
  const hide_header = document.getElementById("hide_header_id");
  const hide_add_to_cart = document.querySelector(".hidde-add-to-cart");
  const hide_arrow = document.getElementById("hide_bottom_arrow");
  const hide_footer_icons = document.getElementById("hide_footer_icons");
  showExtrainfoDialog();
  // Drag and drop file
  const filePanel = document.querySelector(".file-selector");
  const fileInput = document.getElementById("file");
  const fileContainer = document.querySelector('label[for="file"]');
  const fileName = document.getElementById("file-name");

  fileInput?.addEventListener("change", function () {
    const file = this.files[0].name;
    fileName.innerText = file;
    nextPanelAfterInputFile();
  });
  fileContainer?.addEventListener("drop", (e) => {
    e.preventDefault();
    const dt = new DataTransfer();
    dt.items.add(e.dataTransfer.files[0]);
    fileInput.files = dt.files;
    fileName.innerText = dt.files[0].name;
    nextPanelAfterInputFile();
  });
  fileContainer?.addEventListener("dragover", (e) => e.preventDefault());

  function nextPanelAfterInputFile() {
    setTimeout(() => {
      const value = filePanel.getAttribute("option-value");
      const panelName = filePanel.closest(".panels").getAttribute("panelName");

      userSelections[panelName] = value;
      if (panelName === "graduacion") {
        userSelections[panelName] = window.extraInfo[value.trim()];
      }
      updateCristalesDetails();
      calculateSubtotal();
      navigateToNextPanel(panelName, value);
    }, 1000);
  }

  //Options of Gafas de Sol:
  // Function to check and remove elements based on product type
  const productTypeSol = document.querySelector(
    'div[product-type="Gafas de sol"]'
  );
  const productTypeGraduadas = document.querySelector(
    'div[product-type="Gafas graduadas"]'
  );

  if (productTypeSol) {
    if(window.currency.code==="EUR"){
      optionPrices = {
      "Lentes orgánicas índice 1.5": "23,20",
      "Lentes orgánicas índice 1.6": "47,20",
      "Lentes orgánicas índice 1.67": "79,60",
      "Lentes orgánicas índice 1.74": "99,60",
      "Filtro azul para pantallas": "24",
      "Lentes de sol graduadas": "24",
      "Lentes fotocromáticas fotosensibles": "34",
      Polarizado: "38",
      "Zeiss": "40",
      "Essilor": "40",
      "Visual Lens": "0"
    };
    }
    else{
      optionPrices=window.optionPricesCurrencySol;
    }
  } else if (productTypeGraduadas) {
    if(window.currency.code==="EUR"){
      optionPrices = {
      "Lentes orgánicas índice 1.5": "23,20",
      "Lentes orgánicas índice 1.6": "47,20",
      "Lentes orgánicas índice 1.67": "79,60",
      "Lentes orgánicas índice 1.74": "99,60",
      "Filtro azul para pantallas": "24",
      "Lentes de sol graduadas": "24",
      "Lentes fotocromáticas fotosensibles": "58",
      Polarizado: "38",
      "Zeiss": "40",
      "Essilor": "40",
      "Visual Lens": "0"
    };
    }
    else{
      optionPrices=window.optionPricesCurrency;
    }
    
  } else {
   if(window.currency.code==="EUR"){
      optionPrices = {
      "Lentes orgánicas índice 1.5": "23,20",
      "Lentes orgánicas índice 1.6": "47,20",
      "Lentes orgánicas índice 1.67": "79,60",
      "Lentes orgánicas índice 1.74": "99,60",
      "Filtro azul para pantallas": "24",
      "Lentes de sol graduadas": "24",
      "Lentes fotocromáticas fotosensibles": "58",
      Polarizado: "38",
    };
    }
    else{
      optionPrices=window.optionPricesCurrency;
    }
  }

  function checkAndRemoveElements() {
    if (productTypeSol) {
      var divToRemove1 = document.querySelector(
        '.block-selected-products[data-product-id="8942562148651"]'
      );
      if (divToRemove1) {
        divToRemove1.parentNode.removeChild(divToRemove1);
      }
      removeDivsByOptionValue("Lentes orgánicas índice 1.67");
      removeDivsByOptionValue("Lentes orgánicas índice 1.74");
      removeDivsByOptionValue(
        "Lentes standard con antirreflejante y endurecido"
      );
      removeDivsByOptionValue("Filtro azul para pantallas");
      removeDivsByOptionValue("Lentes de sol graduadas");
    }

    if (productTypeGraduadas) {
      removeDivsByOptionValue("Sin Tratamiento");
      removeDivsByOptionValue("Sin Color");
    }
    removeDivsByOptionValue("Sin Color");
  }
  // Function to remove divs based on option-value
  function removeDivsByOptionValue(optionValue) {
    var divsToRemove = document.querySelectorAll(
      '.lens-option-configuration[option-value-es="' + optionValue + '"]'
    );
    divsToRemove.forEach(function (div) {
      div.parentNode.removeChild(div);
    });
  }

  const mutationCallback = function (mutationsList, observer) {
    for (var mutation of mutationsList) {
      if (mutation.type === "childList" || mutation.type === "attributes") {
        checkAndRemoveElements();
      }
    }
  };
  var observer = new MutationObserver(mutationCallback);
  var targetNode = document.querySelector("body");
  var config = { attributes: true, childList: true, subtree: true };
  observer.observe(targetNode, config);
  checkAndRemoveElements();

  function showExtrainfoDialog() {
    const infoDialog = document.getElementById("configurador-extra-info");
    const closeInfoDialog = document.querySelector(".close-extra-info");
    const extraInfoSpans = document.querySelectorAll(".extra-info");

    extraInfoSpans.forEach((span) => {
      span.addEventListener("click", (e) => {
        e.stopPropagation();
        const optionValue = span.getAttribute("option-value");
        const val = window.extraInfo[optionValue];
        infoDialog.querySelector("p").innerHTML = val;
        infoDialog.showModal();
      });
    });
    closeInfoDialog.addEventListener("click", () => {
      infoDialog.close();
    });
  }
  showExtrainfoDialog();

  var panelOrder = ["Gafas Graduadas"];
  var currentPanelIndex = 0;
  function navigateButtonToNextPanel() {
    if (currentPanelIndex < panelOrder.length - 1) {
      currentPanelIndex++;
      updatePanelDisplay(panelOrder[currentPanelIndex]);
    }
  }
  function navigateButtonToPreviousPanel() {
    if (currentPanelIndex > 0) {
      if ((currentPanelIndex === 1) & (totalInitialOption === 1)) {
        console.log("Cant Go Back");
      } 
      else if(userSelections["prescription"]==="" && panelOrder[currentPanelIndex]==="Lentes"){
          currentPanelIndex=1;
          updatePanelDisplay(panelOrder[currentPanelIndex]);
        }
      else {
       
         if (userSelections.tratamientoEs == "Lentes de sol graduadas") {
          if (
            (panelOrder[currentPanelIndex] == "Polarization" &&
              panelOrder[currentPanelIndex - 1] == "Color") ||
            (panelOrder[currentPanelIndex + 1] == "Polarization" &&
              panelOrder[currentPanelIndex] == "Color")
          ) {
            panelOrder[currentPanelIndex] = "Color";
            panelOrder[currentPanelIndex - 1] = "Polarization";
            currentPanelIndex--;
          }
        }
        if (
          (panelOrder[currentPanelIndex] == "Tratamiento") &
          (panelOrder[currentPanelIndex - 1] == "Configurar")
        ) {
          panelOrder.splice(3, 0, "Lentes");
        }
          currentPanelIndex--;
          if(userSelections["graduacionEs"]==="Configurar" ){
            const lentesIndex = panelOrder.indexOf("Lentes");
            const configurarIndex = panelOrder.indexOf("Configurar");
            // Swap the positions if both exist
              if (lentesIndex !== -1 && configurarIndex !== -1) {
                if(lentesIndex<configurarIndex){
                  // Temporary variable to hold "Lentes"
                const temp = panelOrder[lentesIndex];
                panelOrder[lentesIndex] = panelOrder[configurarIndex];
                panelOrder[configurarIndex] = temp;
                }

            }
            if(panelOrder[currentPanelIndex+1]==="Lentes"){

            currentPanelIndex=1;
            userSelections["prescription"]="";
            }
            else if(panelOrder[currentPanelIndex+1]==="Configurar"){
            
             currentPanelIndex=1;
             userSelections["prescription"]="";
            }

          }


        
        if (panelOrder[currentPanelIndex] == "Tratamiento") {
          userSelections["polarizationEs"] = "";
          userSelections["polarization"] = "";
          updateCristalesDetails();
        }
        if (
          userSelections.tratamientoEs == "Lentes fotocromáticas fotosensibles"
        ) {
          if (panelOrder[currentPanelIndex] == "Polarization") {
            currentPanelIndex--;
          }
        }

        updatePanelDisplay(panelOrder[currentPanelIndex]);
      }
    }
  }

  function updateCristalesDetails() {
    var detailsDiv = document.querySelector(".frame-details-cristales");
    detailsDiv.innerHTML = "";
    var detailsHtml = "";
    if (userSelections.graduacion) {
      detailsHtml +=
        "<span>" +
        window.extraInfo.prescription +
        ": " +
        userSelections.graduacion +
        "</span>";
    }
    if (userSelections.lentes) {
      detailsHtml +=
        "<span>" +
        window.extraInfo.glasses +
        ": " +
        userSelections.lentes +
        "</span>";
    }
    if (userSelections.fabricante) {
      detailsHtml +=
        "<span>" +
        window.extraInfo.fabricante +
        ": " +
        userSelections.fabricante +
        "</span>";
    }
    if (userSelections.tratamiento) {
      detailsHtml +=
        "<span>" +
        window.extraInfo.treatment +
        ": " +
        userSelections.tratamiento +
        "</span>";
    }
    if (userSelections.polarization) {
      detailsHtml +=
        "<span>" +
        window.extraInfo.polarization +
        ": " +
        userSelections.polarization +
        "</span>";
    }
    if (userSelections.color) {
      detailsHtml +=
        "<span>" +
        window.extraInfo.color +
        ": " +
        userSelections.color +
        "</span>";
    }

    detailsDiv.innerHTML = detailsHtml;
  }

  function updatePanelDisplay(currentPanel) {
    document.querySelectorAll(".choices-panel").forEach(function (panel) {
      panel.style.display =
        panel.dataset.panelTitle === currentPanel ? "block" : "none";
    });
  }

  var nextButtons = document.querySelectorAll(".next-button");
  var backButtons = document.querySelectorAll(".back-button");
  nextButtons.forEach(function (nextButton) {
    nextButton.addEventListener("click", function () {
      navigateButtonToNextPanel();
    });
  });
  backButtons.forEach(function (backButton) {
    backButton.addEventListener("click", function () {
      navigateButtonToPreviousPanel();
    });
  });

  const mainProductVariantId = window.currentProduct.selected_id;
  const productSku = window.currentProduct.selected_sku;
  const productCentro = window.currentProduct.centro_metafield;

  const match = productSku.match(/^([^\-]+)/);
  const mainProductCodigo = match ? match[1] : null;
  //add condition if the product has only one variant then get its only variants
  var currentProductVariants = [];
  var lensesPopup = document.getElementById("lenses-popup");
  var selectedProductOptions = { Color: [], Lentes: [], Tratamiento: [] };

  function togglePopup(display) {
    lensesPopup.style.display = display;
  }
  function clickLastVisibleElement(className) {
    const elements = document.querySelectorAll(`.${className}`);
    let visibleElements = [];

    elements.forEach((element) => {
      if (window.getComputedStyle(element).display !== "none") {
        visibleElements.push(element);
      }
    });
    totalInitialOption = visibleElements.length;
    if (visibleElements.length === 1) {
      visibleElements[0].click();
    }
  }

  document
    .getElementById("select-lenses-button")
    .addEventListener("click", function () {
      togglePopup("flex");
      hide_header.style.display = "none";
      //clickLastVisibleElement("block-selected-products");
      if (hide_add_to_cart) {
        hide_add_to_cart.style.display = "none";
      }
    });

  document
    .getElementById("close-popup-button")
    .addEventListener("click", function () {
      // Reset the popup display
      togglePopup("none");

      // Reset user selections to their default values
      Object.keys(userSelections).forEach((key) => {
        userSelections[key] = "";
      });
      // Reset UI elements if necessary
      document
        .querySelectorAll(".lens-option-configuration.selected")
        .forEach((option) => {
          option.classList.remove("selected");
        });
      const fileInput = document.getElementById("file");
      const fileName = document.getElementById("file-name");
      if (fileInput && fileName) {
        fileInput.value = ""; // Clear the file input
        fileName.innerText = ""; // Clear the displayed file name
      }

      const lensPriceElement = document.getElementById("lens-price");
      const totalPrice = document.getElementById("total-price");
      const elementsL = document.getElementById("frame-details-cristales");
      elementsL.replaceChildren();
      if (lensPriceElement) lensPriceElement.textContent = window.currency.symbol+"0.00";
      if (totalPrice) totalPrice.textContent = window.currency.symbol+"0.00";

      // Restore visibility of hidden elements
      hide_header.style.display = "grid";
      if (hide_add_to_cart) {
        hide_add_to_cart.style.display = "flex";
      }

      // Reset other UI panels or states as needed
      updatePanelOrderAndDisplay("Gafas Graduadas");
    });

  function attachOptionEventListeners() {
    document
      .querySelectorAll(".lens-option-configuration")
      .forEach(function (option) {
        // Use onclick instead of addEventListener to prevent duplicate listeners
        option.onclick = function () {
          var value = this.getAttribute("option-value");
          var valueEs = this.getAttribute("option-value-es") || value;
          if (value.includes("Cargar")) return;

          var panelName = this.closest(".panels").getAttribute("panelName");
          userSelections[panelName] = value;
          if (panelName === "graduacion") {
            userSelections[panelName] = window.extraInfo[value.trim()];
          }
          userSelections[`${panelName}Es`] = valueEs;
          updateCristalesDetails();
          calculateSubtotal();
          navigateToNextPanel(panelName, valueEs);
        };
      });
  }

  var productId;

  document
    .querySelectorAll(".block-selected-products")
    .forEach(function (product) {
      product.addEventListener("click", function () {
        productId = this.getAttribute("data-product-id");
        var productOptions = window.allProductOptions[productId];
        currentOption = productOptions;
        if (productOptions.TratamientoEs.includes("Polarizado")) {
          productOptions["Polarizado"] = productOptions.Tratamiento.slice(-2);
          productOptions["PolarizadoEs"] =
            productOptions.TratamientoEs.slice(-2);
        }
        if (productOptions) {
          updatePanelOptions(
            "Color",
            productOptions.Color,
            productOptions.ColorEs
          );
          updatePanelOptions(
            "Lentes",
            productOptions.Lentes,
            productOptions.LentesEs
          );
          updatePanelOptions(
            "Tratamiento",
            productOptions.Tratamiento,
            productOptions.TratamientoEs
          );
          updatePanelOptions(
            "Fabricante",
            productOptions.Fabricante,
            productOptions.FabricanteEs
          );
          if (productOptions?.Polarizado) {
            updatePanelOptions(
              "Polarization",
              productOptions.Polarizado,
              productOptions.PolarizadoEs
            );
          }
        }
        eval(
          document.getElementById("product-variants-" + productId).textContent
        );
        currentProductVariants = eval("productVariants" + productId);
        updatePanelOrderAndDisplay("Graduacion");
      });
    });

  function updatePanelOrderAndDisplay(nextPanel) {
    if (!panelOrder.includes(nextPanel)) {
      panelOrder.push(nextPanel);
    }
    currentPanelIndex = panelOrder.indexOf(nextPanel);
    updatePanelDisplay(nextPanel);
  }

  function updatePanelOptions(panelName, options, optionsEs) {
    var panel = document.querySelector(".panel-" + panelName.toLowerCase());
    panel.innerHTML = "";
    var currencyMetaTag = document.querySelector(
      'meta[property="og:price:currency"]'
    );
    var currencyCode = currencyMetaTag ? currencyMetaTag.content : "EUR"; // Default to 'EUR' if not found
    var currencySymbols = {
      EUR: "€",
      USD: "$",
      GBP: "£",
    };

    // Get the currency symbol, default to currency code if not found in the mapping
    var currencySymbol = currencySymbols[currencyCode] || currencyCode;
    options.forEach(function (optionValue, index) {
      const optionDiv = document.createElement("div");
      const childDiv = document.createElement("div");
      const imgDiv = document.createElement("div");
      optionDiv.className = "lens-option-configuration";
      optionDiv.setAttribute("option-value", optionValue);
      optionDiv.setAttribute("option-value-es", optionsEs[index]);
      // if (optionsEs[index] === 'Lentes orgánicas índice 1.5') {
      //     optionDiv.classList.add('lens-option-configuration--disabled');
      //     optionDiv.setAttribute('option-value', null);
      //     optionDiv.setAttribute('option-value-es', null);
      // }

      const p = document.createElement("p");
      p.innerText = optionValue;
      p.classList.add("lens-text");
      optionDiv.appendChild(p);

      // Create a new div for the price
      var priceDiv = document.createElement("div");
      priceDiv.className = "lens-option-configuration-price";
      let gafasSol=0;
      if(productTypeSol && panelName==="Lentes"){
        
        gafasSol=parseFloat(
          optionPrices["Lentes de sol graduadas"].replace(",", "."));
      }
      if(window.subText.hasOwnProperty(optionsEs[index])){
          const br = document.createElement("br");
          br.classList.add("sub-text");
          const subText = document.createElement("span");
          subText.style.fontSize="14px";
          subText.innerText = window.subText[optionsEs[index]];
          subText.classList.add("sub-text");
          p.appendChild(br);
          p.appendChild(subText);
        }
      // Check if the option value is in the optionPrices map
      if (window.extraInfo.hasOwnProperty(optionsEs[index])) {
        
        const sp = document.createElement("span");
        sp.innerText = "i";
        sp.setAttribute("option-value", optionsEs[index]);
        sp.classList.add("extra-info");

        p.appendChild(sp);
      }

      if (optionImgs.hasOwnProperty(optionsEs[index])) {
        const img = document.createElement("img");
        img.src = optionImgs[optionsEs[index]];
        if(optionsEs[index]==="Verde"||optionsEs[index]==="Marrón"||optionsEs[index]==="Gris"){
          img.height = 120;
        }
        else{
          img.height = 90;
        }
        imgDiv.appendChild(img);
      }

      
      if (optionPrices.hasOwnProperty(optionsEs[index])) {
        let totalPrice = parseFloat(optionPrices[optionsEs[index]].replace(",", ".")) + gafasSol;
      let formattedPrice = Math.floor(totalPrice * 100) / 100;
        priceDiv.innerText =
          " +" + formattedPrice.toFixed(2) + currencySymbol;

      } else {
        priceDiv.innerText = window.extraInfo.included;
      }

      // Append the priceDiv to the optionDiv
      childDiv.appendChild(priceDiv);
      childDiv.classList.add("lents-img-container");
      childDiv.classList.add("price-text");
      imgDiv.classList.add("lents-img-container");
      optionDiv.prepend(imgDiv);
      optionDiv.appendChild(childDiv);
      panel.appendChild(optionDiv);
    });

    attachOptionEventListeners();
    showExtrainfoDialog();
  }

  function navigateToNextPanel(panelName, value) {
    var pdInputTd = document.getElementById("only-for-progressive");
    var progressiveElements = document.querySelectorAll(".progressive-element");

    if (productId === "8942562083115") {
      if (pdInputTd) {
        progressiveElements.forEach(function (element) {
          element.style.display = "none";
        });
      }
    } else if (productId === "8942562148651") {
      if (pdInputTd) {
        pdInputTd.style.display = "table-cell";
        progressiveElements.forEach(function (element) {
          element.style.display = "table-cell";
        });
      }
    }
    if (userSelections.lentesEs === "Lentes orgánicas índice 1.74") {
      document
        .querySelectorAll(".lens-option-configuration")
        .forEach(function (option) {
          if (
            [
              "Lentes de sol graduadas",
              "Lentes fotocromáticas fotosensibles",
            ].includes(option.getAttribute("option-value-es"))
          ) {
            option.classList.add("hidden");
          }
        });
    } else {
      document
        .querySelectorAll(".lens-option-configuration")
        .forEach(function (option) {
          if (
            [
              "Lentes de sol graduadas",
              "Lentes fotocromáticas fotosensibles",
            ].includes(option.getAttribute("option-value-es"))
          ) {
            option.classList.remove("hidden");
          }
        });
    }
    if (panelName === "graduacion") {
      if (value === "Configurar") {
        updatePanelOrderAndDisplay("Configurar");
      } else if (value === "Lo tienes") {
        if(userSelections["prescription"]==="" ){
        const lensOptions = document.querySelectorAll('.panels.panel-lentes .lens-option-configuration');

          lensOptions.forEach(function (option) {
            option.removeAttribute('disabled');
          });
        }

      updatePanelOrderAndDisplay("Lentes");
    } else {
       if(userSelections["prescription"]==="" ){
        const lensOptions = document.querySelectorAll('.panels.panel-lentes .lens-option-configuration');

          lensOptions.forEach(function (option) {
            option.removeAttribute('disabled');
          });
        }
      updatePanelOrderAndDisplay("Lentes");
    }
  } else if (panelName === "lentes") {
      updatePanelOrderAndDisplay("Fabricante");
    } 
    else if (panelName === "fabricante") {
      updatePanelOrderAndDisplay("Tratamiento");
    } else if (panelName === "tratamiento") {
      if (productTypeSol) {
        let variantId = findVariantId(userSelections);
        if (value === "Lentes fotocromáticas fotosensibles") {
          updatePanelOrderAndDisplay("Color");
        }
        
        else if (variantId) {
          addToCart(variantId, userSelections,"tratamiento");
        } else {
          console.error("No matching variant found");
        }
      } else {
        if (
          value === "Lentes standard con antirreflejante y endurecido" ||
          value === "Filtro azul para pantallas"
        ) {
          let variantId = findVariantId(userSelections);
          if (variantId) {
            addToCart(variantId, userSelections,"second else");
          } else {
            console.error("No matching variant found");
          }
        } else if (value === "Lentes fotocromáticas fotosensibles") {
          updatePanelOrderAndDisplay("Color");
        } else if (
          value === "Lentes de sol graduadas" ||
          value === "Polarizado"
        ) {
          updatePanelOrderAndDisplay("Polarization");
        } else if (value === "Sin polarizar") {
          updatePanelOrderAndDisplay("Color");
        } else {
          console.log("Unhandled value in Tratamiento panel: " + value);
        }
      }
    } else if (panelName === "color") {
      let variantId = findVariantId(userSelections);
      if (variantId) {
        addToCart(variantId, userSelections,"color");
      } else {
        console.error("No matching variant found");
      }
    } else if (panelName === "polarization") {
      updatePanelOrderAndDisplay("Color");
    } else if (panelName === "Configurar") {
      console.log("userSelections.graduacion", userSelections.graduacion);
    } else {
      console.log("Unhandled panel or value");
    }
  }

  function findVariantId(userSelections) {
    const selections = userSelections;
    let colorUserSelection = currentOption.Color[0];
    if (selections.color) {
      colorUserSelection = selections.color;
    }

    if (
      selections.polarization &&
      selections.tratamientoEs === "Lentes de sol graduadas"
    ) {
      selections.tratamiento = selections.polarization;
      delete selections.polarization;
    }

    const relevantSelections = [
      selections.tratamiento,
      colorUserSelection,
      selections.lentes,
    ];
    for (let i = 0; i < currentProductVariants.length; i++) {
      const variantOptions = currentProductVariants[i].options;
      if (
        variantOptions.includes(relevantSelections[0]) &&
        variantOptions.includes(relevantSelections[1]) &&
        variantOptions.includes(relevantSelections[2])
      ) {
        return currentProductVariants[i].id;
      }
    }
    return null;
  }
  async function compressImage(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);

      reader.onload = (event) => {
        const img = new Image();
        img.src = event.target.result;

        img.onload = () => {
          const canvas = document.createElement("canvas");
          const ctx = canvas.getContext("2d");

          // Set the canvas dimensions to the image dimensions
          const maxWidth = 1024; // Set maximum width for resizing
          const maxHeight = 1024; // Set maximum height for resizing
          let width = img.width;
          let height = img.height;

          // Resize to maintain aspect ratio
          if (width > height) {
            if (width > maxWidth) {
              height *= maxWidth / width;
              width = maxWidth;
            }
          } else {
            if (height > maxHeight) {
              width *= maxHeight / height;
              height = maxHeight;
            }
          }

          canvas.width = width;
          canvas.height = height;

          // Draw the image onto the canvas
          ctx.drawImage(img, 0, 0, width, height);

          // Convert the canvas to a Blob (compressed image)
          canvas.toBlob(
            (blob) => {
              if (blob) {
                resolve(
                  new File([blob], file.name, {
                    type: file.type,
                    lastModified: Date.now(),
                  })
                );
              } else {
                reject(new Error("Image compression failed"));
              }
            },
            file.type,
            0.8 // Compression quality (0.8 = 80%)
          );
        };

        img.onerror = () => {
          reject(new Error("Failed to load image"));
        };
      };

      reader.onerror = () => {
        reject(new Error("Failed to read file"));
      };
    });
  }

  async function addToCart(variantId, userSelections,debug) {
    const elements = document.querySelectorAll(".choices-panel");
    let fabricanteSelection = "";
    elements.forEach((element) => {
      element.style.display = "none";
    });
    document.querySelector(".spinner").style.display = "block";

    let itemsToAdd;
    const lineItemProperties = {};
    const uid = new Date().getTime();
      let prescriptionInfo = {
      };
    for (const key in userSelections) {
      if (
        !["tratamiento", "color", "lentes", "graduacion"].includes(key) &&
        !key.includes("Es")
      ) {
        if (key === "prescription") {

          lineItemProperties["_prescription"] =
            typeof userSelections[key] == "object"
              ? JSON.stringify(userSelections[key])
              : userSelections[key];
          for (const [field, value] of Object.entries(userSelections[key])) {
            let val = value;
            if (Number(value) >0) {
              val = "+" + value;
            }
            
            if(field.includes("Right")){
              if (field.includes("Sphere")) {
                prescriptionInfo[window.window.cartInfoLenses.right_short] =window.cartInfoLenses.sphere+" "+val+" / ";
              }
              else if (field.includes("Cylinder")) {
                prescriptionInfo[window.window.cartInfoLenses.right_short]=prescriptionInfo[window.window.cartInfoLenses.right_short]+ window.cartInfoLenses.cylinder+" "+val+" / ";
              }
              else if (field.includes("Axis")) {
                prescriptionInfo[window.window.cartInfoLenses.right_short] = prescriptionInfo[window.window.cartInfoLenses.right_short]+window.cartInfoLenses.axis+" "+val;
              }
              else if (field.includes("Adittion")) {
                prescriptionInfo[window.window.cartInfoLenses.right_short] = " / "+prescriptionInfo[window.window.cartInfoLenses.right_short]+" "+window.cartInfoLenses.adittion+" "+val;
              }
            }
          }
          for (const [field, value] of Object.entries(userSelections[key])) {
            let val = value;
            if (Number(value) >0) {
              val = "+" + value;
            }
            if(field.includes("Left")){
              if (field.includes("Sphere")) {
                prescriptionInfo[window.window.cartInfoLenses.left_short] =window.cartInfoLenses.sphere+" "+val+" / ";
              }
              else if (field.includes("Cylinder")) {
                prescriptionInfo[window.window.cartInfoLenses.left_short]=prescriptionInfo[window.window.cartInfoLenses.left_short]+ window.cartInfoLenses.cylinder+" "+val+" / ";
              }
              else if (field.includes("Axis")) {
                prescriptionInfo[window.window.cartInfoLenses.left_short] = prescriptionInfo[window.window.cartInfoLenses.left_short]+window.cartInfoLenses.axis+" "+val;
              }
              else if (field.includes("Adittion")) {
                prescriptionInfo[window.window.cartInfoLenses.left_short] = " / "+prescriptionInfo[window.window.cartInfoLenses.left_short]+" "+window.cartInfoLenses.adittion+" "+val;
              }
            }
            if(field.includes("Distanc")){
              if(!isNaN(value)||value!=null){
                prescriptionInfo[window.cartInfoLenses.interpupilar_distance] = value;
              }
              else{
                prescriptionInfo[window.cartInfoLenses.interpupilar_distance] = "_";
              }
            }
          }
          
          for (const [field, value] of Object.entries(prescriptionInfo)) {
            if(field!=window.cartInfoLenses.interpupilar_distance)
            lineItemProperties[field] =value;
          }
          lineItemProperties[window.cartInfoLenses.interpupilar_distance] =prescriptionInfo[window.cartInfoLenses.interpupilar_distance];
        } else if (key === "polarization") {
          if (userSelections[key].length > 0) {
            lineItemProperties[key] =
              typeof userSelections[key] == "object"
                ? JSON.stringify(userSelections[key])
                : userSelections[key];
          }
        } else if(key!="fabricante"){
          lineItemProperties[key] =
            typeof userSelections[key] == "object"
              ? JSON.stringify(userSelections[key])
              : userSelections[key];
        }
      }
      else if (key === "graduacionEs"){
        lineItemProperties["_TipoGraduacion"] =userSelections[key];
        }
        else if (key === "fabricanteEs") {
          fabricanteSelection = userSelections[key];
        }
    }
    let variantIdFabricante = varIdFabricante[fabricanteSelection]||51447473766699;
    if (variantId) {
      itemsToAdd = [
        {
          id: mainProductVariantId,
          quantity: 1,
          properties: {
            "_Related Cristal UID": `main-${uid}`,
            _Codigo_articulo: mainProductCodigo,
            _Centro_articulo: productCentro,
          },
        },
        {
          id: variantId,
          quantity: 1,
          properties: {
            ...lineItemProperties,
            "_Related to Glasses UID": `cristal-${uid}`, // Unique identifier for the cristal
          },
        },
        {
          id: variantIdFabricante,
          quantity: 1,
          properties: {
            "_Related Glasses UID": `fabricante-${uid}`,
          },
        }
      ];
    } else {
      itemsToAdd = [
        {
          id: mainProductVariantId,
          quantity: 1,
          properties: {
            ...lineItemProperties,
            "_Solo Montura": "Si",
            _Codigo_articulo: mainProductCodigo,
            _Centro_articulo: productCentro,
          },
        },
      ];
    }

    const file = fileInput.files[0];

    if (file) {
      try {
        // Compress the image if it's a valid image file
        const compressedFile = file.type.startsWith("image/")
          ? await compressImage(file)
          : file;

        let formData = new FormData();
        formData.append("file", compressedFile);

        // Upload the file
        const response = await fetch(
          "https://webmefy.visual-click.com:3200/upload-file",
          {
            method: "POST",
            body: formData,
          }
        );

        // Process the server response
        if (response.ok) {
          const data = await response.json();
          itemsToAdd[1].properties["_file"] = data.url;
          console.log("File uploaded successfully:", data.url);
        } else {
          console.error("Upload failed:", response.statusText);
        }
      } catch (error) {
        console.error("Error during file upload:", error);
      }
    }
    // Create a dynamic attribute key based on uid and include prescription information
    const dynamicAttributeKey = `Prescription of ${uid}`;
    const attributes = {
      [dynamicAttributeKey]: userSelections["prescription"],
    };

    // Add items to cart with dynamic attributes
    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ items: itemsToAdd, attributes: attributes }),
    })
      .then((response) => response.json())
      .then((data) => {
        // Extract locale from URL between domain and /products
        const pathParts = window.location.pathname.split("/");
        let localePrefix = "";
        // Find the part before 'products' (e.g. /de-ar/products/...)
        for (let i = 1; i < pathParts.length; i++) {
          if (pathParts[i] === "products" && i > 1) {
            localePrefix = pathParts[i - 1];
            break;
          }
        }
        if (localePrefix) {
          window.location.href = `/${localePrefix}/cart`;
        } else {
          window.location.href = "/cart";
        }
      })
      .catch((error) => console.error("Error:", error));
  }
  if (document.getElementById("solo-montura-submission")) {
    document
      .getElementById("solo-montura-submission")
      .addEventListener("click", function () {
        addToCart(null, true,"solo-montura-submission");
      });
  }
  if (document.getElementById("solo-filter-submission")) {
     var currencyMetaTag = document.querySelector(
      'meta[property="og:price:currency"]'
    );
    var currencyCode = currencyMetaTag ? currencyMetaTag.content : "EUR"; // Default to 'EUR' if not found
    var currencySymbols = {
      EUR: "€",
      USD: "$",
      GBP: "£",
    };

    // Get the currency symbol, default to currency code if not found in the mapping
    var currencySymbol = currencySymbols[currencyCode] || currencyCode;
    let priceFiltro=parseFloat(optionPrices["Lentes orgánicas índice 1.5"].replace(",", "."))+parseFloat(optionPrices["Filtro azul para pantallas"].replace(",", "."));
    let formattedPrice = Math.floor(priceFiltro * 100) / 100;
    var priceDiv = document.createElement("div");
    priceDiv.className = "lens-option-configuration-price";
    priceDiv.innerText =" +" + formattedPrice.toFixed(2) + currencySymbol;
    const filterDiv = document.getElementById("solo-filter-submission");
    var priceDivParent = document.createElement("div");
    priceDivParent.className = "price-text";
    priceDivParent.style.alignContent = "center";
    priceDivParent.appendChild(priceDiv);
    filterDiv.appendChild(priceDivParent);


      document
        .getElementById("solo-filter-submission")
        .addEventListener("click", function () {
          addToCartSimple("48778352591147");
        });
  }

  updatePanelOrderAndDisplay("Gafas Graduadas");

  // Function to calculate and update the subtotal
  function calculateSubtotal() {
    let subtotal = 0;
    // Extract the relevant variables from userSelections
    const tratamientoSelection =
      userSelections.tratamientoEs || "Sin Tratamiento";
    const colorSelection = userSelections.colorEs || "Sin Color";
    const lentesSelection = userSelections.lentesEs || "Sin Lentes";
    const fabricanteSelection = userSelections.fabricanteEs || "Sin Fabricante";
    const polarizationSelection =
      userSelections.polarizationEs || "Sin Polarizar";
    let passed=false;// Iterate through relevant selections and add the prices to the subtotal
    if(productTypeSol && userSelections.lentesEs )
    {
     passed=true;
      subtotal += parseFloat(
          optionPrices["Lentes de sol graduadas"].replace(",", "."));
     
    }
   if (optionPrices.hasOwnProperty(tratamientoSelection)) {
      if (tratamientoSelection === "Polarizado" && !passed) {
        subtotal += parseFloat(
          optionPrices["Lentes de sol graduadas"].replace(",", ".")
        );
      }
    
      subtotal += parseFloat(
        optionPrices[tratamientoSelection].replace(",", ".")
      ); // Convert comma to period and parse as float
    }
    if (optionPrices.hasOwnProperty(colorSelection)) {
      subtotal += parseFloat(optionPrices[colorSelection].replace(",", "."));
    }
    if (optionPrices.hasOwnProperty(fabricanteSelection)) {
      subtotal += parseFloat(optionPrices[fabricanteSelection].replace(",", "."));
    }
    if (optionPrices.hasOwnProperty(lentesSelection)) {
      subtotal += parseFloat(optionPrices[lentesSelection].replace(",", "."));
    }
    if (optionPrices.hasOwnProperty(polarizationSelection)) {
      subtotal += parseFloat(
        optionPrices[polarizationSelection].replace(",", ".")
      );
    }
    // Update the lens price element with the calculated subtotal
    var lensPriceElement = document.getElementById("lens-price");
    var totalPrice = document.getElementById("total-price");
    var framePrice = document.getElementById("frame-price");

    if (lensPriceElement) {
      lensPriceElement.textContent = window.currency.symbol+subtotal.toFixed(2)  ;
    }
        if (totalPrice) {
            // Get price from window object
            var price = window.productPrice; // Example: "6.467.000", "34,200.00", "237,60"
            
            // Step 1: Standardize separators for correct parsing
            if (price.includes(",") && price.includes(".")) {
                // Case: "34,200.00" (comma is thousands separator, dot is decimal)
                price = price.replace(/,/g, ""); // Remove commas (thousands separators)
            } else if (price.includes(".") && !price.includes(",")) {
              // Case: "6.467.000" (dot is thousands separator, no decimals)
              // OR "1.500.00" (last dot is a decimal)
          
              // Check if the last dot is followed by exactly two digits (00)
              if (/\.\d{2}$/.test(price)) {
                  // Case: "1.500.00" → Convert last dot to comma (decimal separator)
                  price = price.replace(/\.(?=\d{2}$)/, ",");
              }
          
              // Remove all remaining dots (thousands separators)
              price = price.replace(/\./g, "");
          }
          else if (price.includes(",") && !price.includes(".")) {
                // Case: "237,60" (comma is decimal separator)
                price = price.replace(",", ".");
            }
            
            // Step 2: Convert to float and add subtotal
            let numericPrice = parseFloat(price) + subtotal;
            
            // Step 3: Convert the final number to a string with 2 decimal places
            let textContent = numericPrice.toFixed(2);
            
            // Step 4: Replace decimal dot with a comma (European format)
            textContent = textContent.replace(".", ",");
            
            // Step 5: Insert thousands separators (dots for thousands)
            textContent = textContent.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
            
            // Step 6: Append the currency symbol
           textContent = window.currency.symbol + textContent;

            
            
            // Step 7: Update the total price display
            totalPrice.textContent = textContent;


    }
  }
  async function addToCartSimple(variantId) {
    const uid = new Date().getTime();
    if (variantId) {
      itemsToAdd = [
        {
          id: mainProductVariantId,
          quantity: 1,
          properties: {
            "_Related Cristal UID": `main-${uid}`,
            _Codigo_articulo: mainProductCodigo,
            _Centro_articulo: productCentro,
          },
        },
        {
          id: variantId,
          quantity: 1,
          properties: {
            "_Special": "Filtro luz azul solo",
            "_Related to Glasses UID": `cristal-${uid}`, // Unique identifier for the cristal
          },
        },
      ];
    }

    // Create a dynamic attribute key based on uid and include prescription information
    const dynamicAttributeKey = `Prescription of ${uid}`;
    const attributes = {
      [dynamicAttributeKey]: userSelections["prescription"],
    };

    // Add items to cart with dynamic attributes
    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ items: itemsToAdd, attributes: attributes }),
    })
      .then((response) => response.json())
      .then((data) => {
        console.log("Here is the data received:", data);
        // Extract locale from URL between domain and /products
        const pathParts = window.location.pathname.split("/");
        let localePrefix = "";
        // Find the part before 'products' (e.g. /de-ar/products/...)
        for (let i = 1; i < pathParts.length; i++) {
          if (pathParts[i] === "products" && i > 1) {
            localePrefix = pathParts[i - 1];
            break;
          }
        }
        if (localePrefix) {
          window.location.href = `/${localePrefix}/cart`;
        } else {
          window.location.href = "/cart";
        }
      })
      .catch((error) => console.error("Error:", error));
  }
});
